module.exports = __webpack_public_path__ + "static/media/front.4269eb0c.jpg";